// extracted by mini-css-extract-plugin
module.exports = {"container":"Settings_container__1l0kt","menu":"Settings_menu__L4Cdy"};